import moment from 'moment-timezone'
import settings from '@/libs/constant/settings'
import constants from '@/libs/constant/constants'
import {message, errorHandler, logout, loader, beforeAvatarUpload} from '@/libs/helper'
import {uploadImage, updateUserProfile, getImageUploadURL, API_BASE_URL} from '../../../libs/api/api'
import {compress} from 'image-conversion';

export default{
    name: 'account',
    props:{
        userInformation: {
            type: Object,
            default: {}
        }
    },
    watch:{
        userInformation: function (newValue) {
            this.name= {
                first_name: newValue.first_name || '',
                middle_name: newValue.middle_name || '',
                last_name: newValue.last_name || ''
            }

            this.holderEmail= {
                email: newValue.secondary_email || newValue.email || ''
            }

            this.languageSetting= {
                language: newValue.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB,
                time_zone: newValue.time_zone || moment.tz.guess(true),
                system_lang_tz: newValue.system_lang_tz !== false
            }
        }
    },
    data(){
        return {
            imageName: '',
            visibleCropDialog: false,
            imageCropperConfig: {
                img: '',
                autoCrop: true,
                autoCropWidth: 220,
                autoCropHeight: 220,
                fixedBox: true,
                canMoveBox: true,
                canMove: true

            },
            isImageLoading: false,
            beforeAvatarUpload,
            uploadImageData:{},
            name:{
                first_name: this.$store.getters.getUserInformation.first_name || '',
                middle_name: this.$store.getters.getUserInformation.middle_name || '',
                last_name: this.$store.getters.getUserInformation.last_name || ''
            },
            holderEmail:{
                email: this.$store.getters.getUserInformation.secondary_email || this.$store.getters.getUserInformation.email || ''
            },
            languageSetting: {
                language: this.$store.getters.getUserInformation.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB,
                time_zone: this.$store.getters.getUserInformation.time_zone || moment.tz.guess(true),
                system_lang_tz: this.$store.getters.getUserInformation.system_lang_tz !== false
            },
            availableLanguage:[{
                key: settings.LOCIZE.LANGUAGE.ENGLISH_GB,
                value: '(en-gb) English - Great Britain'
            },{
                key: settings.LOCIZE.LANGUAGE.ENGLISH_US,
                value: '(en-us) English - United States (beta)'
            },{
                key: settings.LOCIZE.LANGUAGE.DUTCH,
                value: '(nl-nl) Dutch'
            },{
                key: settings.LOCIZE.LANGUAGE.GERMAN,
                value: '(de-de) German (beta)'
            }],
            availableTimeZone: moment.tz.names()
        }
    },
    methods: {
        /*
        * saveAccountHolderName() used to save user name.
        * */
        saveAccountHolderName (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.updateAccountInformation(this.name)
                }
            })
        },
        /*
         * verifyAccountHolderEmail() used to verify user email.
         * */
        verifyAccountHolderEmail (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.updateAccountInformation({secondary_email: this.holderEmail.email},
                        'A verification link has been sent to your email, Please verify your email and login',
                        5000
                    )
                }
            })
        },
        /*
         * setLanguageAndTimeZone() sets the language and timezone.
         * */
        setLanguageAndTimeZone (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.languageSetting.language !== this.$store.getters.getUserInformation.language){
                        this.updateAccountInformation(this.languageSetting ,null, null, ()=>{
                            this.$i18n.locale = this.languageSetting.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB
                            localStorage.setItem('lang', this.languageSetting.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
                        });
                    }else{
                        this.updateAccountInformation(this.languageSetting)
                    }
                }
            })
        },
        /*
         * update the user information.
         * */
        updateAccountInformation(body, notification, duration, callback){
            loader(this, true);
            updateUserProfile(body)
                .then((response)=> {
                    if (response.id) {
                        callback && callback()
                        message(this, constants.messageType.SUCCESS, (notification || ('Updated Successfully')), duration);
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                        const { first_name, last_name, middle_name } = response;
                        let collabResponse = this.$store.getters.getOrganisationWithoutCollaborator
                        collabResponse = collabResponse.map((item, index) => {
                            return index === 0 ? {
                                ...item,
                                first_name: first_name,
                                middle_name: middle_name,
                                last_name: last_name
                            } : item
                        })
                        this.$store.dispatch('setOrganisationsWithoutCollaborator', collabResponse)
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        /*
        * set the default language and timezone setting when
        * user on the switch
        * */
        changeSwitchValue(isOn){
            if(isOn) {
                this.languageSetting.time_zone = moment.tz.guess(true)
                let isLanguageAvailable = this.availableLanguage.filter(lang => lang.key === navigator.language)
                if(isLanguageAvailable.length > 0){
                    this.languageSetting.language = isLanguageAvailable[0].key
                }else{
                    this.languageSetting.language = settings.LOCIZE.LANGUAGE.ENGLISH_GB
                }
            }
        },
        /*
         * selectImageToUpload selects the image on the cropping window.
         * */
        selectImageToUpload (e, num) {
            let file = e.target.files[0]
            this.imageName = e.target.files[0].name
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                if (num === 1) {
                    this.imageCropperConfig.img = data
                }
                this.visibleCropDialog =  !this.visibleCropDialog;
            }
            reader.readAsArrayBuffer(file)
        },
        /*
         * uploadImage() uploads the image to the s3 server
         * */
        uploadImage(file){   
            this.isImageLoading = true;
            getImageUploadURL({imageName: this.imageName})
                .then((uploadUrls)=>{
                    this.uploadImageData = uploadUrls;
                    return this.createBlobObject(uploadUrls, file.file)
                }).then((image)=>{
                return uploadImage(image)
            }).then(()=>{
                return updateUserProfile({avatar_image: this.uploadImageData.fileKey})
            }).then((response)=>{
                this.isImageLoading = false;
                message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                this.visibleCropDialog =  !this.visibleCropDialog;
                this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                this.$store.dispatch('setSelectedAccount', response)
                this.$store.dispatch('setRefreshOrganisationList', true)
            }).catch((error)=> {
                this.isImageLoading = false;
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            });
        },
        /*
         * createBlobObject() creates and returns the binary image format to upload
         * */
        createBlobObject(uploadUrl, file){
            return new Promise((resolve) => {
                var reader = new FileReader(file)
                reader.addEventListener("loadend", async function () {
                    const compressedImage = await compress(file ,{
                        quality: 0.8,
                        type: file.type,
                        width: 400,
                        height: 400,
                        scale: 0.8,
                    })
                    return resolve({imageData: compressedImage, uploadUrl })

                });
                reader.readAsArrayBuffer(file);
            })
        },
        getURL(){
            return `${API_BASE_URL}/accounts/files/${this.$store.getters.getUserInformation.avatar_image}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        onError(e) {
            let avatarURL = require('../../../assets/images/img_avatar.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        /*
         * deletes the Avatar image.
         * */
        deleteAvatar(){
            this.isImageLoading = true;
            updateUserProfile({avatar_image:""})
                .then((response)=> {
                    if (response.id) {
                        let accountData = this.$store.getters.getSelectedAccount;
                        message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                        this.$store.dispatch('setSelectedAccount', {
                            ...accountData,
                            avatar_image: ""
                        })
                    }
                    this.isImageLoading = false;
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    this.isImageLoading = false;
                })
        },
        uploadFile (file) {
            this.imageName = file.file.name
            this.uploadImage(file)
        },
        handleAvatarSuccess () {}
    }
}